import { Box, Typography, useTheme } from "@mui/material";
import { ShieldTick } from "iconsax-react";
import { useTranslation } from "react-i18next";

import { CreateShopReviewGroup, CreateShopStepHeading } from "@/components/Molecules";
import type { CreateShopReviewStepProps } from "./CreateShopReviewStep.types";
import * as styles from "./CreateShopReviewStep.styles";

export function CreateShopReviewStep({ reviewGroups }: CreateShopReviewStepProps) {
  const { t } = useTranslation("shops");
  const theme = useTheme();

  return (
    <>
      <CreateShopStepHeading
        titleKey="create.review.title"
        subtitleKey="create.review.subtitle"
        mobileSubtitleKey="create.review.mobileSubtitle"
      />

      <Box sx={styles.groups}>
        {reviewGroups.map((group) => (
          <CreateShopReviewGroup key={group.title} group={group} />
        ))}
      </Box>

      <Box sx={styles.shield}>
        <ShieldTick size={20} variant="Bold" color={theme.palette.primary.main} />
        <Typography sx={styles.text}>{t("create.review.shield")}</Typography>
      </Box>
    </>
  );
}
